import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { VaultProvider } from '@frontend/providers/VaultProvider';
import dynamic from 'next/dynamic';
import { reportWebVitals as ReportWebVitals } from '../hooks/ga';
var VaultPage = dynamic(function () {
  return import('@frontend/containers/Vault');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@frontend/containers/Vault')];
    },
    modules: ["vault.tsx -> " + '@frontend/containers/Vault']
  }
});

var PageCompounding = function PageCompounding() {
  return _jsx(VaultProvider, {
    children: _jsx(VaultPage, {})
  });
};

export var __N_SSG = true;
export default PageCompounding;
export function reportWebVitals(metric) {
  ReportWebVitals(metric);
}